import { Suspense } from 'react'
import { useLocation } from 'react-router-dom'
import Loading from '@/components/shared/Loading'
import type { CommonProps } from '@/@types/common'
import { useAuth } from '@/auth'
import { useThemeStore } from '@/store/themeStore'
import PostLoginLayout from './PostLoginLayout'
import PreLoginLayout from './PreLoginLayout'

// Visitor self-registration (QR code). These pages bring their own full-screen
// layout and must never gain the app shell, even when a session happens to be
// stored in the browser -- the person on screen is a visitor, not the employee
// who is logged in.
const bareLayoutPaths = ['/visitor/qr', '/visitor/register']

const Layout = ({ children }: CommonProps) => {
    const layoutType = useThemeStore((state) => state.layout.type)

    const { authenticated } = useAuth()
    const { pathname } = useLocation()

    if (bareLayoutPaths.includes(pathname)) {
        return (
            <Suspense
                fallback={
                    <div className="flex flex-auto flex-col h-[100vh]">
                        <Loading loading={true} />
                    </div>
                }
            >
                {children}
            </Suspense>
        )
    }

    return (
        <Suspense
            fallback={
                <div className="flex flex-auto flex-col h-[100vh]">
                    <Loading loading={true} />
                </div>
            }
        >
            {authenticated ? (
                <PostLoginLayout layoutType={layoutType}>
                    {children}
                </PostLoginLayout>
            ) : (
                <PreLoginLayout>{children}</PreLoginLayout>
            )}
        </Suspense>
    )
}

export default Layout
